import $ from 'jquery';

export default class Video {
  constructor() {
    var that = this;
    var fn;

    $(document).bind('video-show', function (e, data) {
      let video = data.video,
        endTime = video.endTime,
        autoStartNext = video.autoStartNext,
        next = video.next;

      $('#chessVideo').removeClass('hide').addClass('show');
      $('.qa-section-container').removeClass('show').addClass('hide');
      $('.chessboard-container').removeClass('show-flex').addClass('hide');

      if (!data.audio) {
        $(document).trigger('audio-pause');
      }

      that.displayVideo(video);

      if (endTime) {
        fn = function () {
          if (this.currentTime >= endTime && this.currentTime < (endTime + 0.6)) {
            $("#chessVideo")[0].removeEventListener("timeupdate", fn);
            $(document).trigger('video-hide');
            if (autoStartNext) {
              $(document).trigger('next-config', next);
            }
          }
        }
        $("#chessVideo")[0].addEventListener("timeupdate", fn);
      } else {
        $('#chessVideo').on('ended', function () {
          $(document).trigger('video-hide');
          $("#chessVideo").unbind('ended');

          if (autoStartNext) {
            $(document).trigger('next-config', next);
          }
        })
      }
    }).bind(that);

    $(document).bind('video-hide', function (e, data) {
      if ($("#chessVideo")[0]) {
        $("#chessVideo")[0].removeEventListener("timeupdate", fn);
       $("#chessVideo").unbind('ended');
        that.hideVideo()
      }
    }).bind(that);
  }

  /**
  * @name displayVideo
  * @function
  * @param {video}
  * @description: Play the video
  */
  displayVideo(video) {
    var loadFnc;

    if (!$("#chessVideo")[0]) { return }

    $(".overlay").removeClass('hide').addClass('show');

    loadFnc = function () {
      this.currentTime = video.startTime ? video.startTime : 0;
      $("#chessVideo")[0].removeEventListener("loadedmetadata", loadFnc);
    }

    $('#chessVideo source').attr('src', video.src);
    $("#chessVideo")[0].load();

    $("#chessVideo")[0].addEventListener('loadedmetadata', loadFnc, false);
  }

  /**
  * @name hideVideo
  * @function
  * @param {}
  * @description: Pause the video
  */
  hideVideo() {
    $("#chessVideo")[0].pause();
    $(".overlay").removeClass('show').addClass('hide');
    $('#chessVideo').removeClass('show').addClass('hide');
  }
}


// WEBPACK FOOTER //
// ./src/components/video.js